/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

// api
import schoolApi from "../../api/School";
import classApi from "../../api/Classes";
import subjectApi from "../../api/Subject";
import staffApi from "../../api/Staff";

//css
import "../dashboard/Dashboard.css";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";

//data
import {
  empty,
  errorResponse,
  generateTimeSlots,
  intval,
  isArray,
  isDuringBreak,
  isNormalTimeInterval,
  isObject,
  isString,
  prepareResponseData,
  reIndex,
  timeStringToDate,
} from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import TimeTableWrapper from "../../components/appWrapper/TimeTableWrapper";
import colors from "../../config/colors";
import { Form, Formik } from "formik";
import SelectField from "../../components/form/SelectField";
import MultiSelectField from "../../components/form/MultiSelectField";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { classGroup } from "../../data/ClassGroup";
import FullPageLoader from "../../components/loader/FullPageLoader";

const validationSchema = Yup.object().shape({
  classIds: Yup.array().optional(),
  class_group: Yup.string().required("This field is required!"),
  class_categories: Yup.array().optional(),
  subject_ids: Yup.array().optional(),
  staff_ids: Yup.array().optional(),
});

const TimeTableDashboard = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [pageConfig, setPageConfig] = useState({
    normalClassInterval: 45,
    lessonInterval: user?.periodSettings?.lessonClassInterval
      ? intval(user.periodSettings.lessonClassInterval)
      : 30,
    lessonStartTime: user?.classClockInOut?.lessonStartTime || "03:00 PM",
    classStartTime: user?.schoolClockInOut?.classStartTime || "08:00 AM",
    classDismissalTime:
      user?.schoolClockInOut?.schoolDismissalTime || "04:00 PM",
  });
  const [classes, setClasses] = useState([]);
  const [schoolOpenDays, setSchoolOpenDays] = useState(
    isArray(user?.schoolClockInOut?.schoolOpenDays)
      ? user.schoolClockInOut.schoolOpenDays
      : []
  );
  const [classTemp, setClassTemp] = useState([]);
  const [classHolding, setClassHolding] = useState([]);
  const [isLoading, setIsLoading] = useState(0);
  const [schoolClassSchedules, setSchoolClassSchedules] = useState([]);
  const [periodSection, setPeriodSection] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedNumberOfPeriods, setSelectedNumberOfPeriods] = useState(0);
  const [startTime, setStartTime] = useState(pageConfig?.classStartTime);
  const [classGroupType, setClassGroupType] = useState("");
  const [subjectActivities, setSubjectActivities] = useState({});
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [classCategories, setClassCategories] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [tempSubjects, setTempSubjects] = useState([]);
  const [staff, setStaff] = useState([]);

  const [initialValues, setInitialValues] = useState({
    classIds: [],
    class_group: "",
    class_categories: [],
    subject_ids: [],
    staff_ids: [],
  });

  const toastTR = useRef(null);

  // get school details
  const breakDetails =
    !empty(user) &&
    !empty(user.periodSettings) &&
    !empty(user.periodSettings.breakDetails)
      ? user.periodSettings.breakDetails
      : [];

  useEffect(() => {}, [schoolClassSchedules]);

  useEffect(() => {
    try {
      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let classId = paramState?.classId || "";
        let staffId = paramState?.staffId || "";
        if (classId) {
          setInitialValues((prev) => ({
            ...prev,
            classIds: [classId],
            class_group: "Class",
          }));
          setClassGroupType("Class");
          getSchoolClassSchedules({ classIds: [classId] });
        } else if (staffId) {
          setInitialValues((prev) => ({
            ...prev,
            staff_ids: [staffId],
            class_group: "Staff",
          }));
          setClassGroupType("Staff");
          getSchoolClassSchedules({ staff_ids: [staffId] });
        } else {
          getSchoolClassSchedules({ class_group: 'All' });
        }
      } else {
        getClasses();
        getSchoolClassSchedules({ class_group: 'all' });
      }

      getSubjectActivities();
      getSubjects();
      getStaff();
      getClassCategories();
    } catch (error) {}
  }, [user?._id]);

  useEffect(() => {}, [classTemp]);

  useEffect(() => {
    try {
    } catch (error) {}
  }, [selectedSubjectId]);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  const getSchoolClassSchedules = async (params = {}) => {
    if (!isLoading) setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const classGroup = params?.class_group || "";
      const classIds = params?.classIds || [];
      const classCategoryIds = params?.class_categoryies || [];
      const staffIds = params?.staff_ids || [];
      const subjectIds = params?.subject_ids || [];

      const response = await schoolApi.getSchoolClassSchedules(
        schoolId,
        null,
        null,
        classGroup,
        classIds,
        classCategoryIds,
        staffIds,
        subjectIds
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        setSchoolClassSchedules([]);
        if (
          !empty(
            response_data.response && typeof response_data.response === "string"
          )
        ) {
          return responseDialog(
            "error",
            "Error Alert",
            !empty(response_data.response)
              ? typeof response_data.response === "string"
                ? response_data.response
                : "Failed to fetch school class schedules!"
              : "Failed to fetch school class schedules"
          );
        }
        return;
      }

      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];

      if (!empty(params)) {
        setClassTemp([]);
        const days = [];
        const classIds = [];

        if (!empty(data)) {
          data.forEach((schedule) => {
            const day = schedule?.day || "";
            const classId = schedule?.class?.classId || "";
            if (!empty(day) && !days.includes(day)) {
              days.push(day);
            }

            if (!empty(classId) && !classIds.includes(classId)) {
              classIds.push(classId);
            }
          });
        } else {
          if (isArray(params?.classIds)) {
            const _classIds = params?.classIds || [];
            classIds.push(..._classIds);
          }

          const _days = isArray(user?.schoolClockInOut?.schoolOpenDays)
            ? user.schoolClockInOut.schoolOpenDays
            : [];
          days.push(..._days);
        }

        await getClasses(classIds);
        setSchoolOpenDays(days);
      }
      return setSchoolClassSchedules(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  // get subject activities
  const getSubjectActivities = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await subjectApi.getSubjectActivities(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setSubjectActivities({});
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        const reIndexedData = isArray(data) ? reIndex(data, "_id") : {};
        setSubjectActivities(reIndexedData);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get all active subjects
   * @returns
   */
  const getSubjects = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await subjectApi.getSubjects(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.response) {
        setTempSubjects([]);
        setSubjects([]);
        if (
          !empty(
            response_data.response && typeof response_data.response === "string"
          )
        ) {
          return responseDialog(
            "error",
            "Error Alert",
            !empty(response_data.response)
              ? typeof response_data.response === "string"
                ? response_data.response
                : "Failed to fetch classes!"
              : "Failed to fetch classes"
          );
        }
        return;
      }

      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];

      setSubjects(data);
      return setTempSubjects(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get class categories
   * @returns
   */
  const getClassCategories = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await classApi.getClassCategories(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.response) {
        setClassCategories([]);
        if (
          !empty(
            response_data.response && typeof response_data.response === "string"
          )
        ) {
          return responseDialog(
            "error",
            "Error Alert",
            !empty(response_data.response)
              ? typeof response_data.response === "string"
                ? response_data.response
                : "Failed to fetch class categories!"
              : "Failed to fetch class categories"
          );
        }
        return;
      }

      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];

      return setClassCategories(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get all active classes
   * @returns
   */
  const getClasses = async (classIds = []) => {
    setIsLoading(true);
    try {
      const response = await classApi.getClasses('yes');
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.response) {
        setClasses([]);
        setClassTemp([]);
        if (
          !empty(
            response_data.response && typeof response_data.response === "string"
          )
        ) {
          return responseDialog(
            "error",
            "Error Alert",
            !empty(response_data.response)
              ? typeof response_data.response === "string"
                ? response_data.response
                : "Failed to fetch classes!"
              : "Failed to fetch classes"
          );
        }
        return;
      }

      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];

      const updatedClasses = [];
      const updatedSubjects = [];
      const selectedClassCategoryIds = [];
      if (!empty(classIds)) {
        isArray(data) &&
          data.forEach((_class) => {
            const classId = _class?._id || "";
            const categoryId = _class?.categoryId || "";
            if (
              classIds.includes(classId) &&
              !updatedClasses.includes(_class)
            ) {
              updatedClasses.push(_class);
              if (!selectedClassCategoryIds.includes(categoryId)) {
                selectedClassCategoryIds.push(categoryId);
              }
            }
          });
        isArray(tempSubjects) &&
          tempSubjects.forEach((subject) => {
            const categoryIds = subject?.categories || [];
            if (!empty(categoryIds) && isArray(categoryIds)) {
              categoryIds.forEach((id) => {
                if (selectedClassCategoryIds.includes(id)) {
                  updatedSubjects.push(subject);
                }
              });
            }
          });

        setSubjects(updatedSubjects);
      }

      if (
        !empty(classHolding) ||
        (isArray(updatedClasses) && !empty(updatedClasses))
      ) {
        const _holdingClasses = !empty(classHolding)
          ? classHolding
          : updatedClasses;
        setClassTemp(_holdingClasses);
      } else {
        setClassTemp(data);
      }

      return setClasses(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get all active staff
   * @returns
   */
  const getStaff = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await staffApi.getStaff(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.response) {
        setStaff([]);
        if (
          !empty(
            response_data.response && typeof response_data.response === "string"
          )
        ) {
          return responseDialog(
            "error",
            "Error Alert",
            !empty(response_data.response)
              ? typeof response_data.response === "string"
                ? response_data.response
                : "Failed to fetch staff!"
              : "Failed to fetch staff"
          );
        }
        return;
      }

      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];

      return setStaff(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const timeSlots = generateTimeSlots(
    pageConfig?.normalClassInterval,
    pageConfig?.lessonInterval,
    pageConfig?.classStartTime,
    pageConfig?.classDismissalTime,
    pageConfig?.lessonStartTime,
    breakDetails
  );

  // set data for opening schedule modal
  const openAddUpdatePage = (params) => {
    navigate(null, {
      replace: true,
      state: {
        classId: "",
        periodSection: "",
        day: "",
        subjectId: "",
        numberOfPeriods: "",
        startTime: "",
        endTime: "",
        scheduleId: "",
        subjectActivity: "",
      },
    });
    try {
      const {
        numberOfPeriods,
        day,
        startTime: _startTime,
        endTime: _endTime,
        periodSection: _periodSection,
        subject,
        classId,
        staff,
        scheduleId,
        subjectActivity,
      } = params;
      const subjectId =
        !empty(subject) && !empty(subject.subjectId) ? subject.subjectId : "";
      const staffId =
        !empty(staff) && !empty(staff.staffId) ? staff.staffId : "";

      if (!empty(selectedSubjectId) && selectedSubjectId === subjectId)
        setSelectedSubjectId("");
      if (!empty(periodSection)) setPeriodSection("");
      if (!empty(selectedNumberOfPeriods)) setSelectedNumberOfPeriods("");
      if (!empty(startTime)) setSelectedNumberOfPeriods("");

      navigate("/class-schedule/add-single", {
        state: {
          classId,
          periodSection: _periodSection,
          day,
          subjectId,
          numberOfPeriods,
          startTime: _startTime,
          endTime: _endTime,
          staffId,
          scheduleId,
          subjectActivity,
        },
      });
    } catch (error) {}
  };

  const handleMultiSelectChange = (name, newValue, setFieldValue) => {
    const itemIds = !empty(newValue) && isArray(newValue) ? newValue : [];
    setFieldValue(name, itemIds);

    if (name === "class_categories") {
      const updatedSubjects = [];
      isArray(tempSubjects) &&
        tempSubjects.forEach((subject) => {
          const categoryIds = subject?.categories || [];
          if (!empty(categoryIds) && isArray(categoryIds)) {
            categoryIds.forEach((id) => {
              if (itemIds.includes(id)) {
                updatedSubjects.push(subject);
              }
            });
          }
        });

      setSubjects(updatedSubjects);
      setFieldValue("subject_ids", []);
    }

    if (name === "classIds") {
      const updatedSubjects = [];
      const subjectIds = [];
      const updatedClasses = [];
      isArray(classes) &&
        classes.forEach((_class) => {
          const _subjectIds = _class?.subjects || [];
          const classId = _class?._id || "";
          if (itemIds.includes(classId)) {
            updatedClasses.push(_class);
            subjectIds.push(..._subjectIds);
          }
        });
      setClassHolding(updatedClasses);

      isArray(tempSubjects) &&
        tempSubjects.forEach((subject) => {
          const subjectId = subject?._id || "";
          if (!empty(subjectId) && subjectIds.includes(subjectId)) {
            updatedSubjects.push(subject);
          }
        });

      setSubjects(updatedSubjects);
      setFieldValue("subject_ids", []);
    }
  };

  // handle attendance type
  const handleInputType = (name, setFieldValue) => (e) => {
    const value =
      !empty(e) &&
      !empty(e.target) &&
      !empty(e.target.value) &&
      isString(e.target.value)
        ? e.target.value
        : "";
    setFieldValue(name, value);
    setClassGroupType(value);
    if (value === "All") {
      setSubjects(tempSubjects);
    }
  };

  const searchConstraints = async (values) => {
    try {
      if (values?.class_group === "Staff" && !empty(values?.staff_ids)) {
        delete values?.classIds;
        delete values?.subject_ids;
      }

      if (values?.class_group === "Staff" && empty(values?.staff_ids)) {
        return responseDialog(
          "error",
          "Time table",
          "Please select at least one staff."
        );
      }

      if (values?.class_group === "Category" && !empty(values?.subject_ids)) {
        delete values?.staff_ids;
        delete values?.classIds;
      }

      if (values?.class_group !== "Class" && !empty(values?.classIds)) {
        delete values?.staff_ids;
      }

      getSchoolClassSchedules(values);
    } catch (error) {
      return responseDialog("error", "Time table", "Internal server error.");
    }
  };

  return (
    <>
      <TimeTableWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="School Time Table" />
          {/* end menu header */}
          <div className="mb-20" style={{ width: "100%" }}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={searchConstraints}
            >
              {({ values, setFieldValue }) => (
                <Form style={{ width: "100%" }}>
                  <div className="attendance-dashboard-filter">
                    <SelectField
                      labelTitle="Type"
                      required={true}
                      placeholder="Select Type"
                      name="class_group"
                      options={classGroup}
                      height={50}
                      valueKey="title"
                      selectedOption={values.class_group}
                      handleChangeFunc={handleInputType(
                        "class_group",
                        setFieldValue
                      )}
                      containerWidth={300}
                      width={300}
                    />
                    {classGroupType === "Class" && (
                      <MultiSelectField
                        labelTitle="Classes"
                        placeholder="Select Class(es)"
                        name="classIds"
                        options={classes}
                        required={true}
                        selectedOptions={values.classIds}
                        valueKey="_id"
                        height={50}
                        mt="mt-10"
                        onChange={(e) =>
                          handleMultiSelectChange(
                            "classIds",
                            e.value,
                            setFieldValue
                          )
                        }
                        containerWidth={300}
                        width={300}
                      />
                    )}
                    {classGroupType === "Category" && (
                      <MultiSelectField
                        labelTitle="Classes Categories"
                        placeholder="Select Class Categories"
                        name="class_categories"
                        options={classCategories}
                        selectedOptions={values.class_categories}
                        valueKey="_id"
                        required={true}
                        height={50}
                        mt="mt-10"
                        onChange={(e) =>
                          handleMultiSelectChange(
                            "class_categories",
                            e.value,
                            setFieldValue
                          )
                        }
                        containerWidth={300}
                        width={300}
                      />
                    )}
                    {classGroupType === "Staff" && (
                      <MultiSelectField
                        labelTitle="Staff"
                        placeholder="Select Staff"
                        name="staff_ids"
                        options={staff}
                        required={true}
                        selectedOptions={values.staff_ids}
                        valueKey="_id"
                        height={50}
                        optionLabel="fullName"
                        mt="mt-10"
                        onChange={(e) =>
                          handleMultiSelectChange(
                            "staff_ids",
                            e.value,
                            setFieldValue
                          )
                        }
                        containerWidth={300}
                        width={300}
                      />
                    )}
                    {classGroupType !== "Staff" && (
                      <MultiSelectField
                        labelTitle="Subject(s)"
                        placeholder="Select Subject(s)"
                        name="subject_ids"
                        options={subjects}
                        selectedOptions={values.subject_ids}
                        valueKey="_id"
                        required={true}
                        height={50}
                        mt="mt-10"
                        onChange={(e) =>
                          handleMultiSelectChange(
                            "subject_ids",
                            e.value,
                            setFieldValue
                          )
                        }
                        containerWidth={300}
                        width={300}
                      />
                    )}
                  </div>

                  <div>
                    {values?.class_group || !empty(selectedStudents) ? (
                      <ButtonIcon
                        height={50}
                        marginTop={3}
                        color="#ffffff"
                        backgroundColor="#633ccd"
                        width={150}
                        borderColor="#633ccd"
                        buttonText="Generate"
                        type="submit"
                      />
                    ) : (
                      <div></div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          {/* time table start */}
          <div
            style={{
              maxHeight: "75vh",
              overflowY: "auto",
            }}
          >
            {location?.state?.staffId || !empty(initialValues?.staff_ids) ? (
              <div className="mb-10 mt-20">
                <span>
                  <strong>Total Classes: </strong>
                  {schoolClassSchedules?.length}
                </span>
              </div>
            ) : (
              <div></div>
            )}
            <table className="time-table-view">
              <thead
                style={{
                  position: "sticky",
                  zIndex: 10,
                  top: 0,
                  backgroundColor: colors.primary,
                  color: colors.white,
                }}
              >
                <tr>
                  <th>Day</th>
                  <th>Class/Time</th>
                  {timeSlots?.map((slot, index) => (
                    <th className="fs-12 time-table-intervals" key={index}>
                      {slot?.startTime || ""} - {slot?.endTime || ""}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {schoolOpenDays?.map((day) => {
                  return (
                    !empty(classTemp) &&
                    classTemp?.map((item, classIndex) => {
                      const title =
                        !empty(item) && !empty(item.title) ? item.title : "";
                      const classId =
                        !empty(item) && !empty(item._id) ? item._id : "";

                      return (
                        <tr
                          className="time-table-row bold"
                          key={`${day}-${classIndex}`}
                        >
                          {classIndex === 0 && (
                            <td
                              className="time-table-day"
                              rowSpan={classTemp.length}
                            >
                              {day}
                            </td>
                          )}
                          <td className="time-table-subject py-10 fs-12">
                            {title}
                          </td>
                          {timeSlots?.map((slot, index) => {
                            // Check if this time slot is covered by a schedule item
                            const _slotStartTime =
                              !empty(slot) && !empty(slot.startTime)
                                ? timeStringToDate(slot.startTime).getTime()
                                : "";
                            const scheduleItem = schoolClassSchedules.find(
                              (schedItem) => {
                                const _classData =
                                  !empty(schedItem) && !empty(schedItem.class)
                                    ? schedItem.class
                                    : {};
                                const _classId =
                                  !empty(_classData) &&
                                  !empty(_classData.classId)
                                    ? _classData.classId
                                    : "";
                                const _day =
                                  !empty(schedItem) && !empty(schedItem.day)
                                    ? schedItem.day
                                    : "";
                                const _startTime =
                                  !empty(schedItem) &&
                                  !empty(schedItem.startTime)
                                    ? timeStringToDate(
                                        schedItem.startTime
                                      ).getTime()
                                    : "";
                                const _endTime =
                                  !empty(schedItem) && !empty(schedItem.endTime)
                                    ? timeStringToDate(
                                        schedItem.endTime
                                      ).getTime()
                                    : "";

                                return (
                                  _day === day &&
                                  _classId === classId &&
                                  _startTime <= _slotStartTime &&
                                  _endTime > _slotStartTime
                                );
                              }
                            );

                            // If the schedule spans multiple periods
                            if (scheduleItem) {
                              const numberOfPeriods =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.nubmerOfPeriods)
                                  ? intval(scheduleItem.nubmerOfPeriods)
                                  : 1;
                              const isBreak = isDuringBreak(
                                slot?.startTime,
                                slot?.endTime,
                                breakDetails
                              );
                              const startTime =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.startTime)
                                  ? scheduleItem.startTime
                                  : "";
                              const endTime =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.endTime)
                                  ? scheduleItem.endTime
                                  : "";
                              const periodSection =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.periodSection)
                                  ? scheduleItem.periodSection
                                  : "Normal Time";
                              const staff =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.staff)
                                  ? scheduleItem.staff
                                  : "";
                              const classDetails =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.class)
                                  ? scheduleItem.class
                                  : "";
                              const subject =
                                !empty(scheduleItem) &&
                                !empty(scheduleItem.subject)
                                  ? scheduleItem.subject
                                  : "";
                              const activityTypeId =
                                scheduleItem?.subjectActivityId || "";
                              const activityType =
                                subjectActivities?.[activityTypeId]?.title ||
                                "";

                              // Render the schedule item with numberOfPeriods
                              return (
                                <td
                                  className="fs-12 time-table-subject-title pointer"
                                  key={index}
                                  colSpan={numberOfPeriods}
                                  onClick={() => {
                                    if (isBreak) return;
                                    const classId =
                                      !empty(classDetails) &&
                                      isObject(classDetails) &&
                                      !empty(classDetails.classId)
                                        ? classDetails.classId
                                        : "";
                                    openAddUpdatePage({
                                      numberOfPeriods,
                                      day,
                                      startTime,
                                      endTime,
                                      periodSection,
                                      staff,
                                      classDetails,
                                      subject,
                                      classId,
                                      scheduleId: scheduleItem?._id,
                                      subjectActivity: activityTypeId,
                                    });
                                  }}
                                >
                                  {scheduleItem?.subject?.subjectTitle || " - "}{" "}
                                  <br />
                                  {activityType ? `(${activityType})` : ""}
                                  {/* You may replace this with the subject name */}
                                </td>
                              );
                            }

                            // Check if the current time slot is during a break
                            if (
                              isDuringBreak(
                                slot.startTime,
                                slot.endTime,
                                breakDetails
                              )
                            ) {
                              return (
                                <td
                                  className="fs-12 time-table-break"
                                  key={index}
                                  colSpan={1}
                                >
                                  Break
                                </td>
                              );
                            }

                            // check period section
                            const isNormalTime = isNormalTimeInterval(
                              slot.startTime,
                              slot.endTime,
                              pageConfig?.normalClassInterval
                            );
                            // If no schedule item matches this slot, render an empty cell
                            return (
                              <td
                                className="time-table-empty pointer"
                                key={index}
                                onClick={() => {
                                  openAddUpdatePage(
                                    {
                                      numberOfPeriods: 1,
                                      periodSection: isNormalTime
                                        ? "Normal Time"
                                        : "Lesson Time",
                                      startTime: slot.startTime,
                                      endTime: slot.endTime,
                                      day,
                                      classId,
                                    },
                                    "add_schedule"
                                  );
                                }}
                              >
                                {" "}
                                -{" "}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* time table end */}
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
      </TimeTableWrapper>
    </>
  );
};

export default TimeTableDashboard;
